import React from 'react';

const BlogFeaturedItems = () => {
    return(
        <div className=''>
            <h1 color='white'>Blog Item Chota</h1>
        </div>
    )
}

export default BlogFeaturedItems;